import isNumber from 'lodash/isNumber'

export const USD = 'USD'
export const CAD = 'CAD'
export const MXN = 'MXN'
export const GBP = 'GBP'
export const EUR = 'EUR'
export const ARS = 'ARS'
export const AUD = 'AUD'
export const NZD = 'NZD'
export const COP = 'COP'
export const LTM = 'LTM'

export const CURRENCIES = [USD, CAD, MXN, GBP, EUR, ARS, AUD, NZD, COP, LTM]

export const symbolMap = {
  AUD: '$',
  ARS: '$',
  CAD: '$',
  COP: '$',
  EUR: '€',
  GBP: '£',
  MXN: '$',
  NZD: '$',
  LTM: '$', // LTM is Latin American Pricing in USD and is not a real ISO
  USD: '$',
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 */
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: USD,
})

/**
 * Format a currency value
 * @param {Number} amount
 * @returns {String}
 */
export const formatAmount = (amount) => {
  if (!isNumber(amount)) {
    return '--'
  }
  return formatter.format(amount)
}

const renderCurrencySymbol = (currencyIso) => {
  let symbol = '$'
  if (currencyIso === EUR) {
    symbol = '€'
  }
  if (currencyIso === GBP) {
    symbol = '£'
  }
  return symbol
}

export function formatPrice (currencyIso, amount, showIso) {
  if (!currencyIso || !amount) {
    return undefined
  }

  let price = ''

  if (currencyIso === EUR) {
    price = `${String(amount).replace(/\.00$/, '').replace(/\./, ',')} ${renderCurrencySymbol(currencyIso)}`
  } else {
    price = `${renderCurrencySymbol(currencyIso)}${String(amount).replace(/\.00$/, '')}`
  }

  if (showIso) {
    price = `${price} ${currencyIso}`
  }

  return price
}
